import type { sockApi as SockApi } from '@platform/shared/rpc/socket/sock-api';
import AuthRoutines from '@platform/store/auth-routines';
import { throttle } from 'lodash-es';

export function addSocketAuthRoutines(sockApi: typeof SockApi) {
    AuthRoutines.addRoutine('socketAuth', (sockAuth) => {
        sockApi._.setAuthData(sockAuth);
    });
}

export const refreshSocketAuth = throttle(function () {
    return AuthRoutines.refreshSocketAuth();
}, 8000);
